/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_Column_StartedInputs */

const en_automation_runs_column_started = /** @type {(inputs: Automation_Runs_Column_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started`)
};

const pt_br2_automation_runs_column_started = /** @type {(inputs: Automation_Runs_Column_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início`)
};

/**
* | output |
* | --- |
* | "Started" |
*
* @param {Automation_Runs_Column_StartedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_column_started = /** @type {((inputs?: Automation_Runs_Column_StartedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_Column_StartedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_column_started(inputs)
	return pt_br2_automation_runs_column_started(inputs)
});